import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface ModuleRouteGuardProps {
  moduleCode: string;
  enabledModules: string[];
  enforcementMode?: 'off' | 'observe' | 'enforce';
  children: ReactNode;
  fallback?: ReactNode;
}

function PaywallPage({ moduleCode }: { moduleCode: string }) {
  const moduleName = moduleCode
    .replace(/^(restaurant|beauty|gym)-/, '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
  const vertical = moduleCode.split('-')[0];
  const verticalLabel = vertical === 'restaurant' ? 'Restaurant' : vertical === 'beauty' ? 'Beauty' : vertical === 'gym' ? 'Gym' : 'Striker';

  return (
    <section className="sk-page sk-page--fill" style={{ maxWidth: '640px', margin: '2rem auto' }}>
      <div className="sk-saas-card" style={{
        padding: '2.5rem 2rem',
        textAlign: 'center',
        border: '1px solid var(--sk-border)',
      }}>
        <div style={{
          fontSize: '3rem',
          marginBottom: '1rem',
          opacity: 0.4,
        }}>🔒</div>

        <h2 style={{ fontSize: '1.25rem', fontWeight: 700, margin: '0 0 0.5rem 0' }}>
          Modulo {moduleName} non attivo
        </h2>

        <p style={{ color: 'var(--sk-muted)', fontSize: '0.9rem', lineHeight: 1.5, margin: '0 0 1.5rem 0' }}>
          Questo modulo fa parte del verticale <strong>{verticalLabel}</strong> ed è disponibile
          come add-on acquistabile separatamente. Attivalo dallo Store per sbloccare
          tutte le funzionalità.
        </p>

        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/tenant/store" className="sk-btn" style={{ textDecoration: 'none' }}>
            🛒 Vai allo Store
          </Link>
          <Link to="/tenant" className="sk-btn sk-btn--quiet" style={{ textDecoration: 'none' }}>
            Torna alla dashboard
          </Link>
        </div>

        <p style={{ fontSize: '0.75rem', color: 'var(--sk-muted)', marginTop: '1.5rem', marginBottom: 0 }}>
          Codice modulo: <code style={{ fontSize: '0.7rem', background: 'var(--sk-bg-alt)', padding: '0.1rem 0.3rem', borderRadius: '0.2rem' }}>{moduleCode}</code>
        </p>
      </div>
    </section>
  );
}

export function ModuleRouteGuard({
  moduleCode,
  enabledModules,
  enforcementMode = 'enforce',
  children,
  fallback,
}: ModuleRouteGuardProps) {
  if (enforcementMode === 'off') return children;
  const enabled = new Set(enabledModules.map((code) => code.toLowerCase()));
  if (enabled.has(moduleCode.toLowerCase())) return children;
  if (enforcementMode === 'observe') return children;
  return fallback ?? <PaywallPage moduleCode={moduleCode} />;
}
